import { ChevronRight } from 'lucide-react';
import styled from 'styled-components';

import { Aviso } from '../../../types/aviso';
import { AvisoStatusBadge } from './aviso-status-badge';
import { AvisoTipoBadge } from './aviso-tipo-badge';
import { formatDate } from './format';

interface Props {
  items: Aviso[];
  onOpen: (id: string) => void;
}

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Card = styled.button`
  background: ${({ theme }) => theme.colors.bgSurface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.md};
  padding: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  text-align: left;
  cursor: pointer;
  font-family: inherit;
  color: inherit;
  transition: all ${({ theme }) => theme.transitions.fast};

  &:hover {
    border-color: ${({ theme }) => theme.colors.borderStrong};
  }
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  strong {
    font-weight: 600;
    font-size: 14.5px;
  }
  small {
    font-size: 12.5px;
    color: ${({ theme }) => theme.colors.textMuted};
  }
`;

const Badges = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const AvisosCards = ({ items, onOpen }: Props) => (
  <List>
    {items.map((a) => (
      <Card
        key={a.id}
        type="button"
        onClick={() => onOpen(a.id)}
        data-testid={`aviso-card-${a.id}`}
      >
        <Info>
          <strong>{a.titulo}</strong>
          <Badges>
            <AvisoTipoBadge tipo={a.tipo} />
            <AvisoStatusBadge status={a.status} />
          </Badges>
          <small>
            {formatDate(a.dataInicio)} → {formatDate(a.dataExpiracao)}
          </small>
        </Info>
        <ChevronRight size={18} />
      </Card>
    ))}
  </List>
);
